import { SET_CURRENT_VALUES } from '../actionTypes';
import { profileConfigurationActions } from '../reducer';

export default (values) =>
    profileConfigurationActions[SET_CURRENT_VALUES](values);
